import { Controller } from "@hotwired/stimulus"
import { turboStreamRequest } from "../admin/club_announcements/turbo_stream_helpers"

const MAX_QUANTITY = 100

export default class extends Controller {
  static values = { updateUrl: String, clearUrl: String }
  static targets = ["permalink", "quantity", "variantSelect", "addButton"]

  connect() {
    this._updateAddButtonState()
  }

  async addItem() {
    if (this.hasAddButtonTarget && this.addButtonTarget.disabled) return

    const params = new URLSearchParams({
      'item[permalink]': this.permalinkTarget.value,
      'item[quantity]': this.quantityTarget.value
    })

    if (this.hasVariantSelectTarget) {
      params.set('item[variant_id]', this.variantSelectTarget.value)
    }

    await turboStreamRequest(`${this.updateUrlValue}?${params}`, 'POST')

    if (typeof initFlowbite === 'function') initFlowbite()
    setTimeout(() => {
      const modal = FlowbiteInstances?.getInstance('Modal', 'shopping_cart')
      if (modal) modal.show()
    }, 50)
  }

  changeVariant() {
    const url = this.variantSelectTarget.dataset.url
    const variantId = this.variantSelectTarget.value
    this._updateAddButtonState()
    turboStreamRequest(`${url}?variant_id=${variantId}`)
  }

  _updateAddButtonState() {
    if (!this.hasAddButtonTarget || !this.hasVariantSelectTarget) return
    const selected = this.variantSelectTarget.selectedOptions[0]
    const available = !selected || selected.dataset.available === 'true'
    this.addButtonTarget.disabled = !available
  }

  clear(event) {
    event.preventDefault()
    turboStreamRequest(this.clearUrlValue, 'DELETE')
  }

  removeItem(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-cart-item]")
    if (!row) return

    const params = new URLSearchParams({
      'item[permalink]': row.dataset.permalink,
      'item[variant_id]': row.dataset.variantId || ''
    })

    turboStreamRequest(`${this.updateUrlValue}?${params}`, 'DELETE')
  }

  decrement(event) {
    const input = event.currentTarget.parentElement.querySelector('input')
    const min = parseInt(input.min) || 1
    const value = parseInt(input.value) || 0
    if (value > min) {
      input.value = value - 1
      this._updateButtons(input)
      this._updateItem(input)
    }
  }

  increment(event) {
    const input = event.currentTarget.parentElement.querySelector('input')
    const max = parseInt(input.max) || MAX_QUANTITY
    const value = parseInt(input.value) || 0
    if (value < max) {
      input.value = value + 1
      this._updateButtons(input)
      this._updateItem(input)
    }
  }

  updateQuantity(event) {
    const input = event.currentTarget
    input.value = Math.min(Math.max(parseInt(input.value) || 1, parseInt(input.min) || 1), parseInt(input.max) || MAX_QUANTITY)
    this._updateButtons(input)
    if (input.value === input.dataset.initial) return
    clearTimeout(this._debounceTimer)
    this._debounceTimer = setTimeout(() => this._updateItem(input), 500)
  }

  // Private

  _updateButtons(input) {
    const wrapper = input.parentElement
    const value = parseInt(input.value) || 1
    const min = parseInt(input.min) || 1
    const max = parseInt(input.max) || MAX_QUANTITY
    const decrementBtn = wrapper.querySelector('[data-action*="decrement"]')
    const incrementBtn = wrapper.querySelector('[data-action*="increment"]')
    if (decrementBtn) decrementBtn.disabled = value <= min
    if (incrementBtn) incrementBtn.disabled = value >= max
  }

  _updateItem(input) {
    const row = input.closest("[data-cart-item]")
    if (!row) return

    const params = new URLSearchParams({
      'item[permalink]': row.dataset.permalink,
      'item[variant_id]': row.dataset.variantId || '',
      'item[quantity]': input.value
    })

    turboStreamRequest(`${this.updateUrlValue}?${params}`, 'PUT')
  }
}
